export default __webpack_public_path__ + "static/media/tlo.527f0cd8.PNG";